<template>
  <div
    id="relatorio-contrato"
  >
    <div
      style="margin: 0; padding: 0; min-height: 1190px;"
    >
      <div
        style="font-size: 11pt;"
        v-html="relatorio"
      />
    </div>
  </div>
</template>

<style>
body {
  background-color: #464646 !important;
}

#relatorio-contrato {
    position: relative;
    min-height: 90%;
    width: 1100px;
    margin: auto;
    padding:20px;
    z-index: -1;
    background-color: #fff;
    margin-top: 4rem;
}
</style>

<script>
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'

export default {
  name: 'RelatorioContrato',
  props: {
    contrato: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      relatorio: null,
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    carregar() {
      api.substituirTagsContrato(JSON.parse(localStorage.getItem('contrato'))).then(payload => {
        this.relatorio = payload.data
      })
      localStorage.removeItem('contrato')
    },
  },
}
</script>
